var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv ng-if=\"products.length\"\u003E";








































































































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"row sorting\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"columns medium-5\"\u003E\u003Clabel for=\"sorting\"\u003ESortieren nach:\u003C\u002Flabel\u003E\u003Cselect id=\"sorting\" ng-model=\"sorter.value\" ng-change=\"mppList.order(sorter.value)\" ng-options=\"option.sort as option.name for option in sorter.options\"\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-show=\"producers.length &gt; 1\"\u003E\u003Cdiv class=\"columns medium-1 show-for-medium-up\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-4\"\u003E\u003Clabel for=\"sorting\"\u003EHersteller:\u003C\u002Flabel\u003E\u003Cselect id=\"producer\" ng-model=\"mppBar.selectedProducer\" ng-change=\"mppBar.search()\"\u003E\u003Coption value=\"\"\u003EAlle\u003C\u002Foption\u003E\u003Coption ng-repeat=\"producer in producers\" value=\"{{producer}}\"\u003E{{ producer }}\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "forms.mpp_filters"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!products.length &amp;&amp; mppBar.selectedCategories.main === undefined\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-6\" ng-repeat=\"category in mppBar.mainCategories\"\u003E\u003Cdiv class=\"article box\" ng-click=\"mppBar.selectMain(category.name)\" data-cy=\"mpp.preCheckout.common.categorySelection.cardCategory\"\u003E\u003Cdiv class=\"article-wrap\"\u003E\u003Cdiv class=\"image-wrapper\"\u003E\u003Cimg class=\"full-width\" src=\"\u002Fassets\u002Fimg\u002Fmpp\u002Fcategories\u002F{{category.img}}.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"products.length\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cinfinite-scroll ctrl-callback=\"mppBar.increaseListing()\" observer-element=\".mpp-view\" loading-indicator=\"mppBar.loading_content\"\u003E\u003Cdiv class=\"columns small-6 large-4\" ng-repeat=\"article in products | offset: mppBar.currentPage * mppBar.itemsPerPage | limitTo: mppBar.itemsPerPage | filter: mppBar.$scope.hasSupplyFilter |filter: mppBar.$scope.mainArticleFilter | filter: mppBar.$scope.mobileArticleFilter\"\u003E\u003Cdiv class=\"article box\" ng-click=\"mppList.goToDetail(article.Artikelnummer)\" data-cy=\"mpp.preCheckout.common.itemSelection.cardItem\"\u003E\u003Cdiv class=\"article-wrap\"\u003E\u003Ch4\u003E\u003Csmall\u003E{{ article.Artikelname }}\u003C\u002Fsmall\u003E\u003C\u002Fh4\u003E\u003Ch6 ng-if=\"mppList.hasSupply(article)\"\u003E\u003Csmall class=\"left green\"\u003E\u003C\u002Fsmall\u003E\u003Csmall class=\"right\"\u003EArtikelnummer: {{ article.Artikelnummer }}\u003C\u002Fsmall\u003E\u003Cspan class=\"green\"\u003E{{article.Liefertermin}}\u003C\u002Fspan\u003E\u003C\u002Fh6\u003E\u003Ch6 ng-if=\"!mppList.hasSupply(article) &amp;&amp; (article.Liefertermin == 'in Kürze verfügbar' || article.Liefertermin == 'Bald verfügbar')  \"\u003E\u003Csmall class=\"left yellow\"\u003E\u003C\u002Fsmall\u003E\u003Csmall class=\"right\"\u003EArtikelnummer: {{ article.Artikelnummer }}\u003C\u002Fsmall\u003E\u003Csmall class=\"yellow\"\u003E{{article.Liefertermin}}\u003C\u002Fsmall\u003E\u003C\u002Fh6\u003E\u003Ch6 ng-if=\"!mppList.hasSupply(article) &amp;&amp; !(article.Liefertermin == 'in Kürze verfügbar' || article.Liefertermin == 'Bald verfügbar')\"\u003E\u003Csmall class=\"left red\"\u003EVerfügbarkeit:\u003C\u002Fsmall\u003E\u003Csmall class=\"right\"\u003EArtikelnummer: {{ article.Artikelnummer }}\u003C\u002Fsmall\u003E\u003Csmall class=\"red\"\u003E{{article.Liefertermin}}\u003C\u002Fsmall\u003E\u003C\u002Fh6\u003E\u003Cdiv class=\"image-wrapper\"\u003E\u003Cimg class=\"full-width\" ng-class=\"{&quot;used&quot; : !mppList.hasSupply(article) }\" src=\"{{ article.Bildurl }}\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"price-wrapper\"\u003E\u003Cspan\u003E{{ article['Preis_Brutto'] | currency }}\u003C\u002Fspan\u003E\u003Cspan class=\"right\" ng-if=\"mppList.isMainArticle(article)\"\u003EHauptartikel\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Finfinite-scroll\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!products.length &amp;&amp; mppBar.selectedCategories.main !== undefined\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cp\u003EWir laden aktuell die Artikel bzw. konnten keine Artikel gefunden werden.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;